import { InfoPage, Link } from "@shapr3d/frontend-lib";

export default function ErrorPage() {
  return (
    <InfoPage
      variant="warning"
      title="Something went wrong."
      description={
        <>
          Please try again or follow{" "}
          <Link href="https://support.shapr3d.com/hc/en-us">this link</Link> to submit a support
          ticket.
        </>
      }
    />
  );
}
